exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-line-material {\r\n    top: 0  ;\r\n    position: relative;\r\n    margin: auto;\r\n    width: 100%;\r\n}\r\n\r\n.sk-line-material .sk-child {\r\n    width: 100%;\r\n    height: 4px;\r\n    position: absolute;\r\n    top:0;\r\n    display: inline-block;\r\n    transform-origin: 0% 0%;\r\n    animation: sk-line-material 2s ease-in-out 0s infinite both;\r\n}\r\n\r\n@keyframes sk-line-material {\r\n    0% {\r\n        transform: scaleX(0);\r\n    }\r\n    100% {\r\n        transform: scaleX(1);\r\n    }\r\n}\r\n\r\n#http-loader {\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    position: fixed;\r\n    z-index: 9999;\r\n}\r\n\r\n.loader-bg {\r\n    height: 100%;\r\n    width: 100%;\r\n    position: absolute;\r\n    filter: alpha(opacity=70);\r\n    opacity: 1;\r\n    background-color: rgba(0,0,0,0);\r\n}\r\n\r\n.colored-parent, .colored > div {\r\n    background-color: rgba(26, 188, 156, 0.80);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/app/spinner/spinkit-css/sk-line-material.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-line-material.css
// module chunks = main